/***
 * Created on 2023/11/16
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import ModalDialog from "../modal_dialog/modalDialog";
import PasswordInput from "../form/password_input";
import {useOnChange} from "common/Hook";
// import md5 from "blueimp-md5";
import {useTranslation} from "react-i18next";

function SocialSignupDialog({dispatch, action, socialAccount, metadata, ...props}) {
    const { t } = useTranslation();
    const {values, onChange} = useOnChange({
        password: ''
    })

    const onCreate = async () => {
        await action.mutate({
            ...socialAccount,
            action: 'signup',
            password: values.password,
            tzPath: Intl.DateTimeFormat().resolvedOptions().timeZone
        });
    }

    return (
        <ModalDialog {...props} title={t('@Create Account@')} submitAction={onCreate}>
            <div className="dialog-content">
                <p className='!mb-16'>{t('@We will create QNAP ID and link to your {platform} account, please set QNAP ID password.@', {
                        platform: socialAccount?.platform,
                        interpolation: {
                            prefix: '{',
                            suffix: '}',
                            escapeValue: false
                        }
                    })}</p>
                <div className="dialog__form-group">
                    <PasswordInput
                        label={t('@Password@')}
                        name='password'
                        value={values.password}
                        placeholder={t('@Password@')}
                        onChange={onChange}
                        showTip={true}
                        showStrength={true}/>
                </div>
            </div>
        </ModalDialog>
    );
}

export default SocialSignupDialog;